
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/listing-page",
      function () {
        return require("private-next-pages/elearning/listing-page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/listing-page"])
      });
    }
  